import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import "./SendFeedback.css";

const API_URL = process.env.REACT_APP_API_URL || "RUNTIME_REPLACE_REACT_APP_API_URL";

export default function SendFeedback({ className = "", onOpen, opened = 0, hideTrigger = false }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (opened) setOpen(true);
  }, [opened]);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const [saving, setSaving] = useState(false);

  const close = () => {
    setOpen(false);
    setError("");
    setSent(false);
    setMessage("");
  };

  const submit = async () => {
    const trimmed = message.trim();
    if (!trimmed) {
      setError("Write a short note before sending.");
      return;
    }
    setSaving(true);
    setError("");
    try {
      const res = await fetch(`${API_URL}/feedback`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          message: trimmed,
          path: window.location.pathname,
        }),
      });
      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        setError(body.error || "Feedback could not be sent.");
        return;
      }
      setSent(true);
      setMessage("");
    } catch (err) {
      setError("Feedback could not be sent.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      { !hideTrigger && (
        <button type="button" className={ className } onClick={ () => { onOpen?.(); setOpen(true); } }>
          Feedback
        </button>
      ) }
      { open && createPortal(
        <div className="feedback-backdrop" onClick={ close }>
          <div className="feedback-dialog" onClick={ (event) => event.stopPropagation() }>
            <h2>Send feedback</h2>
            <p>This goes to Solsys. It does not open a crane ticket.</p>
            { sent ? (
              <p className="feedback-sent">Sent. Thank you.</p>
            ) : (
              <textarea
                value={ message }
                onChange={ (event) => setMessage(event.target.value) }
                rows={ 5 }
                maxLength={ 5000 }
                placeholder="What should we know?"
              />
            ) }
            { error && <p className="feedback-error">{ error }</p> }
            <div className="feedback-actions">
              <button type="button" onClick={ close }>Close</button>
              { !sent && (
                <button type="button" onClick={ submit } disabled={ saving }>
                  { saving ? "Sending…" : "Send" }
                </button>
              ) }
            </div>
          </div>
        </div>,
        document.body
      ) }
    </>
  );
}
